import React from 'react';
import _ from 'lodash';
import Select from 'react-select';

import Api from './Config';

 



const TextInfo =()=>{


    return (<div>
       <section> 
     <h3>   What is a Journey?</h3>
Enrolling in a Journey helps you track your blood pressure using a facial scan. Your readings are automatically saved, and you can receive a report to share with your healthcare provider.
</section>
<section>
<h3>How it works:</h3>
Every other day, you'll get a notification to take a facial scan. Once you complete the scan and tap Send, your reading is saved. Readings are NOT shared with your employer.
</section>
 
<section>
<h3>Who's your "why"?</h3>
Monitoring your blood pressure isn't just about numbers—it's about showing up for the people who matter most. High blood pressure is the silent disease—you may not feel it, but it impacts your health and future.
<br/>
Improving your blood pressure can mean more walks with your grandkids, more laughter at family dinners, and more moments with the ones you love. Small changes—like monitoring regularly, walking more, eating less processed food, and reducing stress—can lead to lower blood pressure and more meaningful time together.
</section>
<section>
<h3>How can high blood pressure affect my health?</h3>
It can lead to problems with your:
<ul>
<li><b>Brain</b> – stroke and dementia</li>
<li><b>Eyes</b> – vision loss</li>
<li><b>Heart</b> – heart attack, heart failure</li>
<li><b>Kidneys</b> – kidney failure</li>
<li><b>Sexual function</b> – erectile dysfunction in men and decreased arousal in women</li>
</ul>

</section>
</div>)
}


export default class AutoAddTCodeBP extends React.Component {
  constructor(props) {
    super(props);
    const nowYear = new Date().getFullYear();
    this.state = {
      employers: [],
      selectedEmployer: null,
      selectedDivision: null,
      selectedEmployerName: '',
      employee_id: '',
      employee_initial: '',
      yob: nowYear - 40,
      gender: '',
      loading: false, 
    };

    this.dateRange = _.range(nowYear - 100, nowYear + 1);
        document.body.style.backgroundColor = '#ffffff';
  }

  componentDidMount() {
   // this.getCompanies();
   // change background color to #ffffff
    document.body.style.backgroundColor = '#ffffff !important';
  }
  

 async doEnroll() {
    const {   gender, yob, employee_initial,employee_id } =
      this.state;
    const message = { action: 'ALERT', title: 'Error' };
 
    const selectedEmployerName='';




    if(!employee_initial || !yob ||!employee_id ) {
      message.message = 'Please fill all the required fields.';
    }
    if(employee_id.length < 5) {
      message.message = 'Employee ID should be at least 5 characters.';
    }
    if(employee_initial.length < 2) {
      message.message = 'Initials should be at least 2 characters.';
    }

 




    const { JID, DID, clubID } = this.props.match.params;
this.setState({ loading: true }); 
    const empIdCheckResponse = await Api.CHECK_EMP_ID_EXISTS(employee_id,clubID);
    if (empIdCheckResponse.status === 'success') {
      message.message = 'Employee ID already exists. Please use a different ID.';
    }



    
    if (message.message) {
        this.setState({ loading: false });
          if(! window.ReactNativeWebView)
          {
            alert(message.message);
            return;
          }

      window.ReactNativeWebView.postMessage(JSON.stringify(message));
      return;
    }
    
        
    //generate 9 digit random number for patient reference suffix
    const patient_ref_suffix = 'selfenroll' //Math.floor(100000000 + Math.random() * 900000000)+"";
    const patient_ref = `${employee_id + employee_initial}-${patient_ref_suffix}`;
    Api.addTCodeAutoBP(JID, patient_ref, '', yob, gender, {
        SYSTOLIC: {
            low_emergency: 85,
            low_warning: 95,
            low_alert: 90,
            high_warning: 140,
            high_alert: 145,
            high_emergency: 180
        },
        DIASTOLIC: {
            low_emergency: 50,
            low_warning: 65,
            low_alert: 60,
            high_warning: 90,
            high_alert: 95,
            high_emergency: 120
        }
    }, selectedEmployerName, 'APP_ADDED', DID, clubID)
      .then(({ RESULT, TCODE }) => {
        if (RESULT === 'SUCCESS') {
          message.action = 'ADDTCODE';
          message.TCODE = TCODE;
          // prevent double tap
          window.ReactNativeWebView.postMessage(JSON.stringify(message));
        } else {
          message.message = 'Something went wrong !!';
          window.ReactNativeWebView.postMessage(JSON.stringify(message));
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        message.message = `${err}`;
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
        this.setState({ loading: false });
      });
  }


  render(){
     document.body.style.backgroundColor = '#ffffff !important';
    return (<div style={{ display: 'flex', justifyContent: 'center', padding: 0 }}>
    <div style={{  width: '100%' ,backgroundColor:'#ffffff',padding:20 }}>
      {this.render_form()}
      <TextInfo />
       {this.render_form()}
     
    </div>
  </div>
    )
  }



  render_form() {
    return (
      <form>
        <div style={{ marginTop: 10,   }} className="container-fluid">
          
          <div className="panel1 panel-default1" style={{ margin: 20 }}>
            <div className="panel-heading1">
              <h3 className="panel-title1">To get started, provide the required information below and tap <b>"Enroll"</b>.</h3>
            </div>
            <div
              className="panel-body1"
              style={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: 'min(70vh,240px)',
                justifyContent: 'space-between',
              }}
            >

                <div className="form-group">
                <label>
             Member ID

                </label>
                <input
                  value={this.state.employee_id}
                  onChange={(e) => {
                    const regx = /^[A-Za-z0-9]+$/;
                    const val = `${e.target.value}`;
                    if (val == '' || regx.test(val)) {
                      this.setState({ employee_id: val });
                    }
                  }}
                  size={15}
                  maxLength={15}
                  style={{ width: 200 ,backgroundColor: '#f3f3f3' }}
                  type="text"
                  className="form-control"
                 
                />
              </div>
       
             
 
              <div className="form-group">
                <label>
                  Your Initials (
                  <span style={{ textDecoration: 'none', fontWeight: 'normal', fontStyle: 'italic' }}>
                    First and Last
                  </span>
                  )
                </label>
                <input
                  ref={(ref) => {
                    this.lastField = ref;
                  }}
                  onChange={(e) => {
                    const regx = /^[A-Za-z0-9]+$/;
                    const val = `${e.target.value}`;
                    if (val == '' || regx.test(val)) {
                      this.setState({ employee_initial: val });
                    }
                  }}
                  value={this.state.employee_initial}
                  onKeyUp={(e) => {
                    if (e.keyCode === 13) {
                      this.lastField.blur();
                    }
                  }}
                  size={9}
                  maxLength={2}
                  style={{ width: 100 ,backgroundColor: '#f3f3f3' }}
                  type="text"
                  className="form-control"
                />
              </div>
              <div>
                ( <i>First and Last - For a hyphenated last name, place the initial of the first last name</i> )
                <br/><br/>
              </div>
              <div className="form-group">
                <label>Year of Birth</label>
                <select
                  style={{ width: 100 ,backgroundColor: '#f3f3f3' }}
                  className="form-control"
                  value={this.state.yob}
                  onChange={(e) => {
                    this.setState({ yob: e.target.value });
                  }}
                >
                  {_.map(this.dateRange, (a) => (
                    <option value={a} key={a}>
                      {a}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Gender</label>
                <select
                
                  className="form-control"
                  value={this.state.gender}
                  onChange={(e) => {
                    this.setState({ gender: e.target.value });
                  }}
                  style={{ width: 200 ,backgroundColor: '#f3f3f3' }}
                >
                  <option value="NA">Not specified</option>
                  <option value="MALE">Male</option>
                  <option value="FEMALE">Female</option>
                </select>
              </div>
            </div>

            <div className="panel-footer1" style={{ display: 'flex', justifyContent: 'center',marginTop:30,gap:20  }}>
              <button
                disabled={this.state.loading}
                type="button"
                onClick={() => {
                  this.doEnroll();
                }}
                className="btn btn-success"
                style={{ width: 130 ,borderRadius: 30,fontWeight:'bold' }}
              >
                Enroll
              </button>
              <button
                type="button"
                onClick={() => {
                  const actionObject = { action: 'CLOSE' };
                  window.ReactNativeWebView.postMessage(JSON.stringify(actionObject));
                }}
                className="btn btn-danger"
                 style={{ width: 130,borderRadius: 30,fontWeight:'bold' }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
